import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideosRoutingModule } from './videos-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { PagesModule } from '../pages/pages.module';
import { VideocountComponent } from './videocount/videocount.component';
import { UsersVideoCountComponent } from './users-video-count/users-video-count.component';




@NgModule({
  declarations: [
    VideocountComponent,   
    UsersVideoCountComponent,    
  ],
  imports: [
    CommonModule,
    VideosRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    PagesModule
  ]
})
export class VideosModule { }
